import CONSTANTES from "../constantes";


export const actionGetConfig = () => ({
    type: CONSTANTES.GET_CONFIG
})